module.exports = IcbuIM['Next1'].Dialog;